"use client";
import { j as a } from "./jsx-runtime-CJ-St4mQ.mjs";
import p, { useMemo as c, useCallback as b } from "react";
import { ButtonGroupProvider as f } from "./ButtonGroupContext.js";
import { t as m } from "./tv.config-BuYIgndg.mjs";
const g = m({
  base: [
    "Button__group",
    "inline-flex",
    "group",
    "rounded-md",
    "[&>button]:!rounded-none"
  ],
  variants: {
    fullWidth: {
      true: []
    },
    orientation: {
      horizontal: [
        "flex-row",
        "first:[&>button]:!rounded-l-lg",
        "last:[&>button]:!rounded-r-lg",
        "[&>button]:border-r-0",
        "last:[&>button]:border-r-2"
      ],
      vertical: [
        "flex-col",
        "[&>button]:!rounded-none",
        "first:[&>button]:!rounded-t-lg",
        "last:[&>button]:!rounded-b-lg",
        "[&>button]:border-b-0",
        "last:[&>button]:border-b-2"
      ]
    }
  },
  compoundVariants: [
    {
      orientation: "vertical",
      fullWidth: !0,
      class: ["w-auto"]
    },
    {
      orientation: "horizontal",
      fullWidth: !0,
      class: ["w-full"]
    }
  ]
}), h = (u) => {
  const {
    className: r,
    orientation: t = "horizontal",
    fullWidth: o,
    ...n
  } = u, e = c(
    () => g({
      orientation: t,
      fullWidth: o,
      className: r
    }),
    [t, r, o]
  );
  return { getButtonGroupProps: b(
    (s = {}) => ({
      className: e,
      fullWidth: o,
      role: "group",
      "data-orientation": t,
      orientation: t,
      ...n,
      ...s
    }),
    [e, t, n, o]
  ) };
}, G = p.forwardRef(
  (u, r) => {
    const { getButtonGroupProps: t } = h(u), {
      color: o = "primary",
      size: n = "medium",
      variant: e = "outlined",
      fullWidth: l,
      orientation: s,
      as: i = "div",
      ...d
    } = t();
    return /* @__PURE__ */ a.jsx(
      f,
      {
        fullWidth: l,
        variant: e,
        color: o,
        size: n,
        orientation: s,
        isRenderInGroup: !0,
        children: /* @__PURE__ */ a.jsx(i, { ref: r, ...d })
      }
    );
  }
);
G.displayName = "ButtonGroup";
export {
  G as default
};
